import React, { MouseEventHandler, PropsWithChildren } from "react";
import { Icon } from "@silversea-ssc/ui-components-react";
import * as styles from "./Tags.module.scss";
import { AutocompleteResult } from "./useAutocomplete";
import { TagItem } from "components/FindYourCruise/Components/Autocomplete/tagItem";
import clsx from "clsx";

type Props = {
  tags: TagItem[];
  onRemoveTag: (tag: TagItem) => void;
  darkVariant: boolean;
  autocompleteProps: ReturnType<AutocompleteResult["getListProps"]>;
  wrapContainer: boolean;
};

const Tags: React.FC<PropsWithChildren<Props>> = ({
  children,
  tags,
  onRemoveTag,
  darkVariant = false,
  wrapContainer = false,
  autocompleteProps
}) => {
  const onRemoveTagInner =
    (tag: TagItem): MouseEventHandler<HTMLButtonElement> =>
    (e) => {
      e.stopPropagation();
      onRemoveTag(tag);
    };

  return (
    <ul
      className={clsx(styles.tagsList, {
        [styles.wrapContainer]: wrapContainer
      })}
      {...autocompleteProps}
    >
      {tags.map((tag) => (
        <li key={tag.label} className={styles.tagWrapper}>
          <button
            className={clsx(styles.tag, {
              [styles.darkVariantTag]: darkVariant,
              [styles.lightVariantTag]: !darkVariant
            })}
            type="button"
            onClick={onRemoveTagInner(tag)}
          >
            <span>{tag.label}</span>
            <Icon name="close" size="1x" padding={false} />
          </button>
        </li>
      ))}
      {React.Children.count(children) > 0 && (
        <li className={styles.tagsListContainer}>{children}</li>
      )}
    </ul>
  );
};

export default Tags;
